/**
 * Asserts that the provided array contains exactly the values of the specified enum type.
 * See examples in tests.
 *
 * Note: not really an assert since it requires an intermediate ()
 * but that's a technical reason. It's totally an assert.
 *
 * Note: naming following vitest pattern https://vitest.dev/api/assert-type.html
 */
export function assertType_EnumAndArrayMatch<TEnum>() {
  return <TArray extends readonly TEnum[]>(
    array: TArray & ([TEnum] extends [TArray[number]] ? unknown : 'Invalid')
  ) => array;
}

/**
 * Assert (type) that a value is never = this code branch can never be reached.
 * Typically used in switch statements to ensure all cases are handled.
 *
 * This version doesn't throw:
 * Typically used in FE, where throwing is not desired because the BE may deploy before the FE
 * and you want to handle breaking cases gracefully
 */
export function checkNever(_: never): undefined {
  return undefined;
}

/**
 * Assert (type) that a value is never = this code branch can never be reached.
 * Typically used in switch statements to ensure all cases are handled.
 *
 * This version throws:
 * Typically used in BE, where we want to fail fast on unexpected cases.
 */
export function assertNever(x: never): never {
  throw new Error(`Unexpected value: "${x}"`);
}
